






































































































































































































































import {Component, Vue} from "vue-property-decorator";

@Component({})
export default class CustomerAgreement extends Vue {
  get bgColor() {
    return this.$store.getters["common/bgColor"];
  }

  get locker() {
    return localStorage.getItem('localLang')
  }

  mounted() {
    if ( this.$route.query.origin === 'official' ) {   
      this.hideNavBar();
    }
  }
  hideNavBar() {
    const navBar = document.querySelector('.navBar');
    if (navBar) {
        // @ts-ignore
        navBar.style.display = 'none';
    }
    const viewRouter = document.querySelector('.view-router');
    if (viewRouter) {
        // @ts-ignore
        viewRouter.style.paddingTop = '0px';
    }
  }
  
}
